module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <header class=\"title\">\n        <h1>404</h1>\n        <h2>We can't find your page</h2>\n      </header>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/404/error-404-page.component.html
// module id = ./src/app/system/core/404/error-404-page.component.html
// module chunks = main